import { BarcodeTypeId } from '@/types/barcode'
import Datalogic from './datalogic'
import Zebra from './zebra'

export enum ScannerApiType {
  Datalogic = 'Datalogic',
  Zebra = 'Zebra'
}

export enum ScannerListenerType {
  Scan = 'scan'
}

export interface ScannerListenerReturnType {
  [ScannerListenerType.Scan]: { data: string | number, type: BarcodeTypeId & string }
}

export interface ScannerOptions {
  destroyOnNavigate?: boolean
}

export const ApiDict:Record<ScannerApiType, Scanner<any, any>> = {
  [ScannerApiType.Datalogic]: new Datalogic(),
  [ScannerApiType.Zebra]: new Zebra()
}

export const DEFAULT_HANDLERS = {
  listener: {
    success: data => data,
    error: e => e
  }
}

export abstract class Scanner<CB = any, S extends ScannerListenerReturnType = ScannerListenerReturnType> {
  listeners: Map<string, any>
  options: ScannerOptions
  // get supported (): boolean | Promise<boolean> { return false }
  supported (): boolean | Promise<boolean> { return false }
  constructor (options: ScannerOptions) { this.listeners = new Map(); this.options = options }
  abstract listen <T extends ScannerListenerType = ScannerListenerType> (eventType: T, success?:(data: S[T]) => void, error?:(error: any) => void): CB
  abstract mute (event: string): void
  abstract destroy (id?: string): void
}

// export default interface Scanner<CB = any, S = any> { new(options: ScannerOptions): IScanner<CB, S> }

class ScannerDeviceManager {
  private _device?: Scanner

  constructor () {
    this.init().then(device => {
      this._device = device
    }).catch(console.error)
  }

  get current (): ScannerApiType | undefined {
    return ScannerApiType.Datalogic
  }

  // returns the first currently available scanner api
  get device (): Scanner | undefined {
    return this._device
  }

  getDevice (): Promise<Scanner | undefined> {
    return this.matchSupportedDeviceApi()
  }

  private async matchSupportedDeviceApi (): Promise<Scanner | undefined> {
    let matched: undefined | Scanner = undefined
    const apis = Object.keys(ApiDict)
    let current:string | undefined = undefined
    do {
      current = apis.shift()
      if (ApiDict[current as string] && (await ApiDict[current as string]?.supported())) matched = ApiDict[current as string]
    } while (!matched && apis.length > 0)

    return matched
  }

  // init & determine the current device api by exhaustive feature check
  private init (): Promise<Scanner | undefined> {
    return this.matchSupportedDeviceApi()
  }
}

export default new ScannerDeviceManager()
